module.exports = __webpack_public_path__ + "static/acv_logo_white-54565601560a82f8de29c4448d29c011.png";